import Vue from 'vue';
import header from './header';
import footer from './footer';
import weixin from './weixin';
import login from './login';
import jxszHeader from './jxsz/header';
import jxszLogin from './jxsz/login';
import jxszFooter from './jxsz/footer';

import { ProjectSettings } from '../base/base.js';
const kComponents = {
  install: function (Vue) {
    if (ProjectSettings.Name === 'JXSZJZY') {
      Vue.component('k-header', jxszHeader);
      Vue.component('k-login', jxszLogin);
      Vue.component('k-footer', jxszFooter);
    } else {
      Vue.component('k-header', header);
      Vue.component('k-login', login);
    Vue.component('k-footer', footer);
    }
    // Vue.component('jxsz-header', jxszHeader);
    Vue.component('k-weixin', weixin);
  }
};

Vue.use(kComponents)
export default { header, footer, weixin, login };



// WEBPACK FOOTER //
// ./src/views/home/index.js